import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BuildConfig, CustomWindow } from '@dgx-pr-spa/shared/util';

declare let window: CustomWindow;

/**
 * Provides dynamic runtime environment configuration.
 * See https://labs.thisdot.co/blog/runtime-environment-configuration-with-angular
 * for more information.
 * Wherever environment-specific configuration is required it can be accessed
 * via the config property of the injected service.
 */
@Injectable({
  providedIn: 'root',
})
export class BuildConfigService {
  config: BuildConfig;

  constructor(private http: HttpClient) {}

  loadConfig() {
    return new Promise<void>((resolve) =>
      this.http
        .get<BuildConfig>('./config.json')
        .toPromise()
        .then((config) => {
          this.config = config;
          this.fixZoomIssue();
          resolve();
        })
    );
  }

  fixZoomIssue() {
    const addMaximumScaleToMetaViewport = () => {
      const el = document.querySelector('meta[name=viewport]');

      if (el !== null) {
        let content = el.getAttribute('content') as string;
        const re = /maximum\-scale=[0-9\.]+/g;

        if (re?.test(content)) {
          content = content.replace(re, 'maximum-scale=1.0');
        } else {
          content = [content, 'maximum-scale=1.0'].join(', ');
        }

        el.setAttribute('content', content);
      }
    };

    const checkIsIOS = () =>
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (checkIsIOS()) {
      addMaximumScaleToMetaViewport();
    }
  }
}
